import { RefObject, useEffect } from 'react';

/**
 * Custom hook for conditionally focusing an input element and optionally selecting its text.
 * This provides a declarative alternative to imperative useEffect patterns for focus management.
 *
 * @param ref - Reference to the HTML input element
 * @param condition - Boolean condition that determines when to apply focus
 * @param selectText - Whether to select all text in the input after focusing (default: true)
 */
export const useConditionalFocus = <T extends HTMLInputElement>(
  ref: RefObject<T | null>,
  condition: boolean,
  selectText: boolean = true,
) => {
  useEffect(() => {
    if (condition && ref.current) {
      ref.current.focus();
      if (selectText) {
        ref.current.select();
      }
    }
  }, [condition, ref, selectText]);
};
